<template>
<div class="right-content">
    <div style="font-size: 24px; font-wwight: bold"><span style="color:red">*</span>关键词： <Input v-model="keyword" placeholder="请输入新的关键词" clearable style="width: 200px" /></div>
    <template>
        <Card style="width:100%; margin-top: 20px">
            <RadioGroup v-model="text" size="large" @on-change="getOldInfo()">
                <div class="radio-item">
                    <Radio label="text" size="large">
                        <Icon type="md-text" size="22" />
                        <span>文字</span>
                    </Radio>
                </div>
                <div class="radio-item">
                    <Radio label="image" size="large">
                        <Icon type="md-photos" size="22" />
                        <span>图片</span>
                    </Radio>
                </div>
                <div class="radio-item">
                    <Radio label="text_and_images" size="large">
                        <Icon type="md-images" size="22" />
                        <span>图文</span>
                    </Radio>
                </div>
            </RadioGroup>
        </Card>
    </template>
    <!-- 文字方式 -->
    <Card v-show="text == 'text'" style="width:100%; margin-top:20px">
        <div style="text-align:center">
            <Input v-model="informationText" type="textarea" :rows="4" placeholder="请输入文字..." />
        </div>
    </Card>
    <!-- 图片方式 -->
    <Card v-show="text == 'image'" style="width:100%; margin-top:20px">
        <template>
            <Button class="push-img-btn" icon="ios-cloud-upload-outline" :disabled="imageFile!=null">{{push_image_media_id?'更新图片':'上传图片'}}<input id="pushimg" class="file-input" type="file" accept="image/*" @change="addFile('image')" ref="inputer" :disabled="imageFile!=null"></Button><span style="color: red">（最多上传一张图片，图片大小限制为10mb之内，支持bmp/png/jpeg/jpg/gif格式，建议尺寸360*200）</span>
            <div class="push-imgpreview">
                <img src="" alt="" id="preview" v-show="imageFile">
                <div v-show="imageFile"><Button type="error" @click="delPushImage">删除</Button></div>
            </div>
        </template>
    </Card>
    <!-- 图文方式 -->
    <Card v-show="text == 'text_and_images'" style="width:100%; margin-top:20px">
        <template>
            <RadioGroup v-model="type" size="large" @on-change="onSelectPushAriticel">
                <div class="radio-item">
                    <Radio label="http" size="large">
                        <Icon type="ios-link" size="22" />
                        <span>外链接</span>
                    </Radio>
                </div>
                <div class="radio-item">
                    <Radio label="article" size="large">
                        <Icon type="ios-paper-outline" size="22" />
                        <span>选择文章</span>
                    </Radio>
                </div>
            </RadioGroup>
            <div class="link" v-show="type == 'http'">
                <div style="color: red">请务必按照：关键词、外链接、标题、简介、封面（最后上传）的顺序进行设置，否则会不生效！</div>
                <div class="input-item"><span style="color: red">＊</span><span class="input-title">外链接：</span><Input prefix="ios-link" placeholder="请输入链接地址：https://" v-model="pushGraphicOtherUrl" style="width: 400px" clearable /><span style="color: red"> （请上传http或者https格式）</span></div>
                <div class="input-item"><span style="color: red">＊</span><span class="input-title">标 题：</span><Input maxlength="10" prefix="ios-pricetags-outline" v-model="pushGraphicOtherTitle" placeholder="请输入标题" style="width: 400px" clearable /><span style="color: red"> （标题最多10字）</span></div>
                <div class="input-item"><span style="color: red">＊</span><span class="input-title">简介：</span><Input maxlength="20" prefix="ios-create-outline" v-model="pushGraphicOtherIntroduction" placeholder="请输入简介" style="width: 400px" clearable /><span style="color: red"> （简介最多20字）</span></div>
                <span style="color: red">＊</span><span class="input-title">封面：</span><span style="color: red">（最多只能上传一张图片，图片大小限制为10m之内，支持bmp/png/jpeg/jpg/gif格式，建议尺寸360*200）</span>
                <div style="margin-top:10px">
                    <Button class="push-img-btn" icon="ios-cloud-upload-outline" :disabled="coverImages!=null">{{push_graphic_other_thumb?'更新封面':'上传封面'}}<input id="pushcover" class="file-input" type="file" accept="image/*" @change="addFile('http')" ref="inputer2" :disabled="coverImages!=null"></Button>
                    <div class="push-imgpreview" v-show="coverImages">
                        <img src="" alt="" id="preview_link" ref='thumb'>
                        <div><Button type="error" @click="delHttpImage">删除</Button></div>
                    </div>
                </div>

            </div>
            <!-- 文章方式 -->
            <div class="link" v-show="type == 'article'">
                <div class="card-con">
                    <div class="card-item">
                        <Card class="article-item" style="display:inline-block; width:250px; height:180px; margin:10px 20px" v-for="(item, index) in articleArr" :key="index">
                            <div class="select-icon" v-if="index == currentArticle">
                                <Icon type="md-checkmark-circle" size="24" color="#19be6b" />
                            </div>
                            <div class="title-desc" @click="selectArticle(item,index)">
                                <!-- <img style="width: 160px; height: 160px" :src="item.content.news_item[0].thumb_url"> -->
                                <h3 style="margin-top:10px">{{item.content.news_item[0].title}}</h3>
                                <h4 style="margin-top:10px">{{item.content.news_item[0].digest}}</h4>
                                <Button class="article-detail" @click="articleDetail(item)" type="info">查看文章</Button>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>

        </template>
    </Card>
    <!-- 是否开启推送 -->
    <Card class="switch-btn" style="width:100%;" v-if="text != ''">
        <div>
            <Button type="primary" @click="submitInfoSetting">保存</Button>
        </div>
    </Card>
    <!-- 加载 -->
    <Spin size="large" fix v-if="spinShow"></Spin>
</div>
</template>

<script>
import host from '../../js/host'

export default {
    data() {
        return {
            token: '',
            keyword: '',
            text: 'text', //选择模式
            informationText: '', //文字模式的填写内容
            switchInformation: false, //是否开启推送
            formInline: { //图片推送的图片
                images: [],
            },
            imageFile: null, //图片推送的图片
            coverImages: null, //封面图片
            shadeIndex: -1,
            type: 'http',
            spinShow: false,
            currentArticle: null, // 当前选择的文章
            pushGraphicArticleMediaId: null, // 当前选择的文章id
            pushGraphicOtherUrl: '', //外链接
            pushGraphicOtherTitle: '', //外联标题
            pushGraphicOtherIntroduction: '', //外链描述
            push_graphic_other_thumb: '', //已上传封面
            push_image_media_id: null,
            articleArr: [], //文章列表
        }
    },
    methods: {
        change(status) {
            this.$Message.info('开关状态：' + (status == true ? '已开启' : '已关闭'));
        },
        //图片模式--上传图片回调
        upimgs(response) {
            // this.imgs.push(response.)
            if (response.code === 0) {
                this.formInline.images.push('' + response.data.url);
            }
        },
        //语文模式--上传图片回调
        getOldInfo() {
            console.log(111)
            // this.getInfo()
        },
        //选择文章
        selectArticle(item, index) {
            if (this.currentArticle === null) {
                this.currentArticle = index
                this.pushGraphicArticleMediaId = item.media_id
            } else {
                if (this.currentArticle == index) {
                    this.currentArticle = null
                    this.pushGraphicArticleMediaId = null
                } else {
                    this.currentArticle = index
                    this.pushGraphicArticleMediaId = item.media_id
                }
            }
            console.log(this.pushGraphicArticleMediaId)
        },
        //提交
        submitInfoSetting() {
            let keyword = this.keyword
            let type = this.text
            let modal_content = ''
            let pushContent = this.informationText
            let file = this.imageFile

            let pushGraphicOtherUrl = this.pushGraphicOtherUrl
            let pushGraphicOtherTitle = this.pushGraphicOtherTitle
            let pushGraphicOtherIntroduction = this.pushGraphicOtherIntroduction
            let pushGraphicArticleMediaId = this.pushGraphicArticleMediaId
            if (type == 'text_and_images') {
                if (this.type == 'http') {
                    type = 'graphicOther'
                    if (pushGraphicOtherUrl) {
                        let form = this.coverImages
                        modal_content = '<div>设置发送关键词返回外部链接</div>'
                        this.$Modal.confirm({
                            title: '确定保存当前设置吗？',
                            content: modal_content,
                            onOk: () => {
                                this.spinShow = true
                                this.$axios.post('/weixin/admin/createKeyword',
                                    this.coverImages, {
                                        headers: {
                                            Authorization: this.token
                                        }
                                    }).then(res => {
                                    this.spinShow = false
                                    if (res.data.code === 0) {
                                        // this.formInline.images[0] = res.data.data.push_image_url
                                        this.$Message.success('设置成功')
                                        this.$router.replace({
                                            path: '/KeywordsSittings'
                                        })
                                    } else if (res.data.code === -1) {
                                        this.$Message.error('请重新上传图片')
                                    } else if (res.data.code === -2) {
                                        this.$Message.error('该关键词已存在，请重新输入')
                                    }
                                })
                            },
                            onCancel: () => {
                                // this.$Message.info('Clicked cancel');
                            }
                        });
                    } else {
                        this.$Message.warning('请设置外部链接');
                        return false
                    }
                } else if (this.type == 'article') {
                    type = 'graphic'
                    if (pushGraphicArticleMediaId) {
                        modal_content = '<div>设置关键词为公众号文章</div>'
                        this.$Modal.confirm({
                            title: '确定保存当前设置吗？',
                            content: modal_content,
                            onOk: () => {
                                this.spinShow = true
                                this.$axios.post('/weixin/admin/createKeyword', {
                                    type: type,
                                    keyword: this.keyword,
                                    pushGraphicArticleMediaId: pushGraphicArticleMediaId,
                                }, {
                                    headers: {
                                        Authorization: this.token
                                    }
                                }).then(res => {
                                    this.spinShow = false
                                    if (res.data.code === 0) {
                                        this.$Message.success('设置成功')
                                        this.$router.replace({
                                            path: '/KeywordsSittings'
                                        })
                                    } else if (res.data.code === -1) {
                                        this.$Message.error('设置失败')
                                    } else if (res.data.code === -2) {
                                        this.$Message.error('该关键词已存在，请重新输入')
                                    }
                                })
                            },
                            onCancel: () => {
                                // this.$Message.info('Clicked cancel');
                            }
                        });
                    } else {
                        this.$Message.warning('请选择文章');
                        return false
                    }
                }
            } else if (type == 'text') {
                if (pushContent) {
                    modal_content = '<div>设置发送关键词返回文字</div>'
                    this.$Modal.confirm({
                        title: '确定保存当前设置吗？',
                        content: modal_content,
                        onOk: () => {
                            this.spinShow = true
                            if (type == 'text') {
                                this.$axios.post('/weixin/admin/createKeyword', {
                                    keyword: keyword,
                                    type: type,
                                    pushContent: pushContent,
                                }, {
                                    headers: {
                                        Authorization: this.token
                                    }
                                }).then(res => {
                                    this.spinShow = false
                                    if (res.data.code === 0) {
                                        this.$Message.success('设置成功')
                                        this.$router.replace({
                                            path: '/KeywordsSittings'
                                        })
                                    } else if (res.data.code === -1) {
                                        this.$Message.error('设置失败')
                                    } else if (res.data.code === -2) {
                                        this.$Message.error('该关键词已存在，请重新输入')
                                    }
                                })
                            }
                        },
                        onCancel: () => {
                            // this.$Message.info('Clicked cancel');
                        }
                    });
                } else {
                    this.$Message.warning('请填写推送文字');
                    return false
                }
            } else if (type == 'image') {
                if (file) {
                    modal_content = '<div>设置关键词为图片模式</div>'
                    this.$Modal.confirm({
                        title: '确定保存当前设置吗？',
                        content: modal_content,
                        onOk: () => {
                            this.spinShow = true
                            if (type == 'image') {
                                this.$axios.post('/weixin/admin/createKeyword',
                                    this.imageFile, {
                                        headers: {
                                            Authorization: this.token
                                        }
                                    }).then(res => {
                                    this.spinShow = false
                                    if (res.data.code === 0) {
                                        //   this.currrntPushImage = res.data.data.push_image_url
                                        this.formInline.images[0] = res.data.data.push_image_url
                                        this.$Message.success('设置成功')
                                        this.$router.replace({
                                            path: '/KeywordsSittings'
                                        })
                                    } else if (res.data.code === -1) {
                                        this.$Message.error('请重新上传图片')
                                    } else if (res.data.code === -2) {
                                        this.$Message.error('该关键词已存在，请重新输入')
                                    }
                                })
                            }
                        },
                        onCancel: () => {
                            // this.$Message.info('Clicked cancel');
                        }
                    });
                } else {
                    this.$Message.warning('请上传图片');
                    return false
                }
            }

        },
        submit(type) {
            console.log(333)
        },
        addFile(type) {
            if (this.keyword) {
                let that = this;
                if (type == 'image') {
                    let pushimgSize = this.GetfileSize('pushimg')
                    if (pushimgSize < 10) {
                        let inputDOM = that.$refs.inputer;
                        let file = inputDOM.files[0];
                        let form = new FormData();
                        form.append('file', file);
                        form.append('type', 'image');
                        form.append('keyword', this.keyword)
                        this.imageFile = form
                        //文件预览
                        let preview = document.querySelector('#preview')
                        let imgUrl = window.URL.createObjectURL(file)
                        preview.setAttribute("src", imgUrl)
                        // 更改img url 以后释放 url
                        preview.onload = function () {
                            // console.log('图片加载成功')
                            URL.revokeObjectURL(imgUrl)
                        }
                    } else {
                        this.$Message.error('图片尺寸过大')
                        return false
                    }

                } else if (type == 'http') {
                    let pushcoverSize = this.GetfileSize('pushcover')
                    console.log(this.GetfileSize('pushcover'))
                    if (pushcoverSize <= 10) {
                        let pushGraphicOtherUrl = this.pushGraphicOtherUrl
                        let pushGraphicOtherTitle = this.pushGraphicOtherTitle
                        let pushGraphicOtherIntroduction = this.pushGraphicOtherIntroduction
                        let fileDOM = that.$refs.inputer2
                        let file = fileDOM.files[0];
                        let form = new FormData();
                        form.append('keyword', this.keyword)
                        form.append('file', file);
                        form.append('type', 'graphicOther');
                        form.append('pushGraphicOtherUrl', pushGraphicOtherUrl);
                        form.append('pushGraphicOtherTitle', pushGraphicOtherTitle);
                        form.append('pushGraphicOtherIntroduction', pushGraphicOtherIntroduction);
                        this.coverImages = form
                        //文件预览
                        let preview = document.querySelector('#preview_link')
                        let imgUrl = window.URL.createObjectURL(file)
                        preview.setAttribute("src", imgUrl)
                        // 更改img url 以后释放 url
                        preview.onload = function () {
                            URL.revokeObjectURL(imgUrl)
                        }
                    } else {
                        this.$Message.error('图片尺寸过大')
                        return false
                    }

                }
            } else {
                this.$Message.info('请先填写关键词')
                this.delPushImage();
                this.delHttpImage();
            }

        },
        delPushImage() {
            this.imageFile = null
            this.push_image_media_id = null
            let preview = document.querySelector('#preview')
            let inputDOM = this.$refs.inputer;
            inputDOM.value = "";
        },
        delHttpImage() {
            this.coverImages = null
            this.push_graphic_other_thumb = null
            let preview = document.querySelector('#preview_link')
            let inputDOM = this.$refs.inputer2;
            inputDOM.value = "";
        },
        //当选择公众号文章时
        onSelectPushAriticel(e) {
            if (e === 'article') {
                this.getArticle()
            } else {
                return false
            }
        },
        //获取文章列表，
        getArticle() {
            this.$axios.post('/weixin/admin/getNews', {}, {
                headers: {
                    Authorization: this.token
                }
            }).then(res => {
                if (res.data.code === 0) {
                    let articleArr = res.data.data.data.item
                    console.log(articleArr)
                    this.articleArr = articleArr
                    if (this.pushGraphicArticleMediaId != null) {
                        for (let i = 0; i < articleArr.length; i++) {
                            if (articleArr[i].media_id == this.pushGraphicArticleMediaId) {
                                this.currentArticle = [i]
                                console.log(i)
                            }
                        }
                    }
                } else if (res.data.code === -1) {
                    this.$Message.error('文章列表加载失败')
                } else if (res.data.code === -2) {
                    this.$Message.error('该关键词已存在，请重新输入')
                }
            })
        },

        //获取文件尺寸
        GetfileSize(elementID) {
            let file = document.getElementById(elementID)
            let size = 0
            if (file.value) {
                if (file.files) {
                    size = file.files[0].size
                } else {
                    let imgid = "img" + elementID
                    let obj_img = document.getElementById(imgid)
                    obj_img.dynsrc = file.value
                    size = obj_img.fileSize
                }
            }
            return (size / (1024 * 1024)).toFixed(3)
        },
        //查看文章详情
        articleDetail(item) {
            window.open(item.content.news_item[0].url)
        }
    },
    created() {
        this.token = localStorage.getItem('token')
    },
    mounted() {

    }
}
</script>

<style>
.right-content {
    /* background: #fff; */
}

.radio-item {
    display: inline-block;
    margin: 0 20px;
}

.switch-btn {
    line-height: 50px;
    font-size: 14px;
    color: #464c5b;
    background: #fff;
    padding: 10px 20px;
    margin-top: 20px;
}

.imgs-box {
    display: inline-block;
    width: 200px;
    height: 200px;
    margin: 10px 10px 10px 0;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid #ccc;
    border-radius: 10px;
}

.imgesd-box {
    display: inline-block;
    width: 200px;
    height: 200px;
    margin: 10px 10px 10px 0;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid #ccc;
    border-radius: 10px;
}

.img-shutter {
    width: 100%;
    height: 100%;
    float: left;
    background-color: rgba(0, 0, 0, 0.5);
    position: relative;
    border-radius: 10px;
}

.ico {
    font-size: 30px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
}

.link {
    margin-top: 20px;
}

.input-item {
    margin: 20px 0;
}

.input-item .input-title {
    display: inline-block;
    min-width: 80px;
}

.card-con {
    display: flex;
}

.card-item {
    flex: auto;
    max-height: 450px;
    margin: 10px 20px;
    overflow: scroll;
}

.select-icon {
    position: absolute;
    top: 10px;
    right: 15px;
}

.file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.push-imgpreview {
    margin: 15px 20px;
}

#preview {
    max-height: 300px;
}

.push-img-btn {
    position: relative;
    width: 120px;
    overflow: hidden;
}

.article-item {
    text-align: left;
    width: 250px;
    height: 160px;
    vertical-align: top;
    overflow: hidden;
    text-overflow: ellipsis;
}

.title-desc {
    position: absolute;
    width: 220px;
    height: 160px;
    top: 20;
    left: 50%;
    transform: translateX(-50%);
}

.article-detail {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
}

#preview_link {
    max-height: 300px;
}

.tips {
    color: red;
    margin-left: 10px;
}
</style>
